import { ref, uploadBytesResumable } from "firebase/storage";

/**
 * Uploads a curator-picked replacement image (as a data URL from
 * `PhotoUpload`) to Firebase Storage and returns the hosted CDN URL. Mirrors
 * the upload convention in `multi-photo-upload.tsx`: derive the URL from the
 * uploaded object's `fullPath` rather than `getDownloadURL`.
 *
 * `@/firebaseConfig` is imported lazily (not at module top level) because it
 * initializes Firebase Remote Config at load, which throws under jsdom
 * (no IndexedDB). A static import here would crash every test that
 * transitively imports the resolution-components registry, not just ones that
 * actually upload. The dynamic import defers that to real upload time.
 */
export async function uploadHitlReplacementImage(
  eventId: string,
  dataUrl: string,
): Promise<string> {
  const { storage } = await import("@/firebaseConfig");
  const blob = await (await fetch(dataUrl)).blob();
  const path = `tina-hitl/${eventId}/${Date.now()}`;
  const snap = await uploadBytesResumable(ref(storage, path), blob);
  return `https://cdn.musicofourdesire.com/${snap.metadata.fullPath}`;
}
